module.exports = __webpack_public_path__ + "img/6.5d036f36.png";